import actionCreatorFactory from "typescript-fsa";
import { CommonAsyncType } from "../../core/types";
import { ClientListRequestBody, ClientListResponse } from "../../core/api/requests/client/list/types";
import { ClientDetailRequestBody, ClientDetailResponse } from "../../core/api/requests/client/detail/types";
import { ClientCreateResponse, ClientCreateResquestBody } from "../../core/api/requests/client/create/types";
import { ClientEditRequestBody, ClientEditResponse } from "../../core/api/requests/client/edit/types";

const actionCreator = actionCreatorFactory("@@Client");

export const clientActions = {
    fetchClients: actionCreator.async<CommonAsyncType<ClientListResponse> & ClientListRequestBody, ClientListResponse>("FETCH_CLIENTS"),
    getClientDetails: actionCreator.async<CommonAsyncType<ClientDetailResponse> & ClientDetailRequestBody, ClientDetailResponse>("GET_CLIENT_DETAILS"),
    createNewClient: actionCreator.async<CommonAsyncType<ClientCreateResponse> & ClientCreateResquestBody, ClientCreateResponse>("CREATE_NEW_CLIENT"),
    updateClientReadStatus: actionCreator.async<CommonAsyncType<ClientEditResponse> & ClientEditRequestBody & { id: string }, ClientEditResponse>("UPDATE_CLIENT_READ_STATUS"),
    resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
}